export default {
    "navigation": "Navigation",
    "offices": "Offices",
    "team": "Team",
    "venous-center": "Venous center",
    "services": "Services",
    "about-us": "About us",
    "news": "News",
    "contacts": "Contacts",
}
